'use strict';

exports.__esModule = true;
exports.transformPostsAuthors = exports.transformPostsCategories = exports.transformPostsMedia = exports.transformPosts = undefined;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _doctifyUtils = require('doctify-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transformPosts = exports.transformPosts = function transformPosts(posts) {
	return [].concat(posts.map(function (post) {
		return {
			category: (post.categories || []).length ? post.categories[0] : '',
			time: (0, _moment2.default)(post.modified_gmt).format('DD-M-YYYY'),
			title: post.title.rendered.replace('&#8217;', '\''),
			authorImage: '',
			author: post.author,
			backgroundImage: post.featured_media,
			suffix: '',
			specialistUri: '',
			link: (0, _doctifyUtils.getResourcePath)('/blog/articles/' + post.slug)
		};
	}));
};

var transformPostsMedia = exports.transformPostsMedia = function transformPostsMedia(posts, media) {
	var path = void 0;
	var index = null;
	for (var i = 0; i < posts.length; i++) {
		if (posts[i].backgroundImage === media.id) {
			path = media.media_details.sizes.large.source_url;
			index = i;
			break;
		}
	}
	if (index !== null) {
		var updatedPosts = posts.slice(0);
		updatedPosts[index].backgroundImage = path.replace(/^\/\//, 'https://');
		return updatedPosts;
	}
	return posts;
};

var transformPostsCategories = exports.transformPostsCategories = function transformPostsCategories(posts, categories) {
	var index = null;
	for (var i = 0; i < posts.length; i++) {
		if (posts[i].category === categories[0].id) {
			index = i;
			break;
		}
	}
	if (index !== null) {
		var updatedPosts = posts.slice(0);
		updatedPosts[index].category = categories[0].name.replace('&amp;', '&');
		return updatedPosts;
	}
	return posts;
};

var transformPostsAuthors = exports.transformPostsAuthors = function transformPostsAuthors(posts, author) {
	var index = null;
	for (var i = 0; i < posts.length; i++) {
		if (posts[i].author === author.id) {
			index = i;
			break;
		}
	}
	if (index !== null) {
		var updatedPosts = posts.slice(0);
		updatedPosts[index].author = author.name;
		updatedPosts[index].authorImage = author.avatar_urls['48'].replace(/^\/\//, 'https://');
		return updatedPosts;
	}
	return posts;
};


// WEBPACK FOOTER //
// ./components/home-page/lib/transformers/blog-banner.js